<template>
    <div id="main">
        <div>
            <h3 class="titleChannel"><i class="fa-solid fa-wifi"></i> Học viên online</h3>
        </div>
        <div class="ml-2">
            <div>
                <div class="row m-0 pb-2 d-flex justify-content-start flex-wrap container-search-sort" id="search-sort">
                    <div class="col col-md-2 pl-0 wrap-search">
                        <div content="Tìm kiếm theo email" v-tippy class="input-group">
                            <div class="input-group-prepend">
                                <div class="input-group-text"><i class="fa-solid fa-magnifying-glass"></i></div>
                            </div>
                            <input v-model="search.email" type="text" class="form-control"
                                placeholder="Tìm kiếm theo email">
                        </div>
                    </div>
                    <div class="col col-md-2 pl-0 wrap-search">
                        <div content="Tìm kiếm theo tên" v-tippy class="input-group">
                            <div class="input-group-prepend">
                                <div class="input-group-text"><i class="fa-solid fa-magnifying-glass"></i></div>
                            </div>
                            <input v-model="search.fullname" type="text" class="form-control"
                                placeholder="Tìm kiếm theo tên">
                        </div>
                    </div>
                    <div class="col col-md-2 pl-0 wrap-typesort">
                        <select content="Trạng thái hoạt động" v-tippy class="form-control"
                            v-model="big_search.user_status">
                            <option value="all">All</option>
                            <option value="online">Online</option>
                            <option value="offline">Offline</option>
                        </select>
                    </div>
                    <div class="col col-md-2 pl-0 wrap-typesort">
                        <select content="Kiểu sắp xếp" v-tippy class="form-control"
                            v-model="big_search.order_direction">
                            <option value="asc">Tăng dần</option>
                            <option value="desc">Giảm dần</option>
                        </select>
                    </div>
                    <div class="col col-md-2 pl-0 wrap-sortby">
                        <select content="Sắp xếp theo" v-tippy class="form-control" v-model="big_search.order_by">
                            <option value="id">ID</option>
                            <option value="fullname">Tên</option>
                            <option value="email">Email</option>
                        </select>
                    </div>
                    <div class="col col-md-1 pl-0 wrap-paginate" id="page">
                        <select content="Phân trang" v-tippy class="form-control" v-model="big_search.per_page">
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="15">15</option>
                            <option value="20">20</option>
                        </select>
                    </div>
                </div>
                <div class="tableData">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th scope="col"><i class="fa-solid fa-signature"></i> Tên</th>
                                <th><i class="fa-solid fa-envelope"></i> Email</th>
                                <th><i class="fa-solid fa-wifi"></i> Trạng thái hoạt động</th>
                                <th><i class="fa-solid fa-clock"></i> Thời gian hoạt động gần nhất</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(student, index) in students" :key="student.user_id">
                                <td>{{ (big_search.page - 1) * big_search.per_page + index + 1 }}</td>
                                <td class="table-cell">
                                    <div class="nameAvatar">
                                        <img :src="student.avatar ? student.avatar : require('@/assets/avatar.jpg')"
                                            alt="">
                                        <span class="nameMember">{{ student.fullname }}</span>
                                    </div>
                                </td>
                                <td>{{ student.email }}</td>
                                <td>
                                    <span v-if="getStatus(student.user_id)" class="text-success">
                                        Đang hoạt động
                                    </span>
                                    <span v-else class="text-danger">
                                        Không hoạt động
                                    </span>
                                </td>
                                <td>{{ getLastSeen(student.user_id) || 'Chưa có dữ liệu' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div id="divpaginate" class="mt-2 container-number-record">
                    <paginate v-if="paginateVisible" :page-count="last_page" :page-range="3" :margin-pages="1"
                        :click-handler="clickCallback" :initial-page="big_search.page" :prev-text="'Prev'"
                        :next-text="'Next'" :container-class="'pagination'" :page-class="'page-item'">
                    </paginate>
                    <div class="number_record text-primary">
                        {{ to_record }} / {{ total }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import useEventBus from '@/composables/useEventBus';
import UserRequest from '@/restful/UserRequest';
const { emitEvent } = useEventBus();
import Paginate from 'vuejs-paginate-next';
import config from '@/config';
import _ from 'lodash';
import { ref, onValue } from 'firebase/database';
import { realtimeDb } from '@/firebase';

export default {
    name: "ManageStudentOnline",
    components: {
        paginate: Paginate,
    },
    setup() {
        document.title = "Học viên online | Techbim";
    },
    data() {
        return {
            config,
            total: 0,
            to_record: 0,
            last_page: 1,
            paginateVisible: true,
            search: {
                email: '',
                fullname: '',
            },
            big_search: {
                per_page: 20,
                page: 1,
                order_by: 'id',
                order_direction: 'desc',
                user_status: 'online', // Trạng thái hoạt động: all, online, offline
            },
            query: '',
            students: [],
            isLoading: false,
            statusData: {}, // Dữ liệu trạng thái từ Realtime Database
            /*
                {
                    "status": {
                        "1": {
                            "is_active": 1,
                            "last_seen": "2025-07-04T12:57:27.841Z",
                            "user_id": 1
                        },
                        "2": {
                            "is_active": 1,
                            "last_seen": "2025-07-04T12:57:57.850Z",
                            "user_id": 2
                        },
                        "3": {
                            "is_active": 1,
                            "last_seen": "2025-07-04T12:30:55.474Z",
                            "user_id": 3
                        }
                    }
                }
            */
        };
    },
    created() {
        this.listenToOnlineStatus();
    },
    mounted() {
        emitEvent('eventTitleHeader', 'Học viên online');
        this.$emitEvent('eventActiveTab', '');
        const queryString = window.location.search;
        const searchParams = new URLSearchParams(queryString);
        this.search.email = searchParams.get('email') || '';
        this.search.fullname = searchParams.get('fullname') || '';
        this.big_search = {
            per_page: parseInt(searchParams.get('per_page')) || 20,
            page: searchParams.get('page') || 1,
            order_by: searchParams.get('order_by') || 'id',
            order_direction: searchParams.get('order_direction') || 'desc',
            user_status: searchParams.get('user_status') || 'online', // Trạng thái hoạt động
        };
        this.getOnlines();
    },
    methods: {
        async listenToOnlineStatus() {
            const statusRef = ref(realtimeDb, '/status'); // Lắng nghe toàn bộ node /status
            onValue(statusRef, (snapshot) => {
                this.statusData = snapshot.val() || {};
                this.getOnlines();
            }, (error) => {
                console.error('Error listening to /status:', error);
            });
        },
        reRenderPaginate() {
            if (this.big_search.page > this.last_page) this.big_search.page = this.last_page;
            this.paginateVisible = false;
            this.$nextTick(() => { this.paginateVisible = true; });
        },
        getOnlines: async function () {
            this.isLoading = true;
            this.query = `?email=${this.search.email}&fullname=${this.search.fullname}&order_by=${this.big_search.order_by}&order_direction=${this.big_search.order_direction}&page=${this.big_search.page}&per_page=${this.big_search.per_page}&user_status=${this.big_search.user_status}`;
            window.history.replaceState({}, null, this.query);
            try {
                const { data } = await UserRequest.post('user-online' + this.query, { status_data: this.statusData });
                this.students = data.data || [];
                this.total = data.total || 0;
                this.to_record = data.to || 0;
                this.last_page = data.last_page || 1;
            } catch (error) {
                if (error.messages) emitEvent('eventError', error.messages[0]);
                this.students = [];
            }
            this.isLoading = false;
            this.reRenderPaginate();
        },
        clickCallback(pageNum) {
            this.big_search.page = pageNum;
            this.getOnlines();
        },
        getStatus(userId) {
            const status = this.statusData[userId];
            return status ? status.is_active === 1 : false;
        },
        getLastSeen(userId) {
            const status = this.statusData[userId];
            if (status && status.last_seen) {
                const date = new Date(status.last_seen);
                return date.toLocaleString('vi-VN', {
                    hour: '2-digit',
                    minute: '2-digit',
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    timeZone: 'Asia/Ho_Chi_Minh',
                });
            }
            return 'Chưa có dữ liệu';
        },
    },
    watch: {
        big_search: {
            handler: function () {
                this.getOnlines();
            },
            deep: true
        },
        search: {
            handler: _.debounce(function () {
                this.big_search.page = 1;
                this.getOnlines();
            }, 500),
            deep: true,
        },
    }
}
</script>

<style scoped>
/* Giữ nguyên style */
</style>

<style scoped>
.container-number-record {
    display: flex;
    justify-content: space-between;
}

.container-number-record .pagination {
    width: fit-content;
}

.number_record {
    font-weight: bold;
    padding-right: 30px;
}

.div_microphone {
    cursor: pointer;
}

.titleChannel {
    font-size: 19px;
    color: var(--user-color);
}

tr th {
    color: var(--user-color);
}

.colorTitle {
    color: gray;
}

.tableData {
    min-height: 20vh;
    overflow-y: scroll;
    font-weight: bold;
    text-align: center;
}

.nameAvatar {
    display: flex;
    align-items: center;
    align-content: center;
}

.deleteMember .fa-trash:hover {
    transition: all 0.5s ease;
    color: red;
}

.deleteMember .fa-trash-arrow-up:hover {
    transition: all 0.5s ease;
    color: green;
}

.deleteMember {
    transition: all 0.5s ease;
    font-size: 20px;
}

.lockMember {
    transition: all 0.5s ease;
    font-size: 20px;
}

.lockMember .fa-lock:hover {
    transition: all 0.5s ease;
    color: red;
}

.lockMember .fa-lock-open:hover {
    transition: all 0.5s ease;
    color: green;
}

.nameAvatar img {
    border-radius: 100%;
    width: 30px;
    height: 30px;
}

.nameMember {
    margin-left: 10px;
}

.link-a:hover {
    cursor: pointer;
    text-decoration: underline;
    color: rgb(0, 102, 255);
}

#main {
    padding: 10px 20px;
    /* min-width: 375px !important; */
}

#page {
    margin-right: auto;
    min-width: 78px;
}

table {
    font-size: 12px;
}

table img {
    width: 40px;
    height: 40px;
    object-fit: cover;
}

.table-cell {
    font-weight: bold;
    vertical-align: middle;
}

table button {
    padding: 1px 3px;
    margin-right: 2px;
}

table thead th {
    vertical-align: middle;
    text-align: center;
}

.action {
    display: flex;
    align-items: center;
    justify-content: center;
}

.form-control {
    height: calc(1.5em + .5rem + 2px);
    padding: .25rem .5rem;
    font-size: .875rem;
    border-radius: 0.2rem;
    line-height: 1.5;
}

@media screen and (min-width: 1201px) {
    table {
        max-width: 100%;
        vertical-align: middle;
    }

    .nameAvatar {
        min-width: 150px;
    }

    .displaytext {
        min-width: 150px;
        overflow: hidden;
        -webkit-line-clamp: 3 !important;
        -webkit-box-orient: vertical;
    }

    table img {
        min-width: 40px;
        min-height: 40px;
        max-width: 40px;
        max-height: 40px;
        object-fit: cover;
    }

    td .fa-solid {
        font-size: 20px;
    }

}

@media screen and (max-width: 1200px) {
    table {
        max-width: 100%;
        vertical-align: middle;
    }

    .nameAvatar {
        min-width: 120px;
    }

    .displaytext {
        min-width: 100px;
        overflow: hidden;
        -webkit-line-clamp: 3 !important;
        -webkit-box-orient: vertical;

    }

    .break {
        word-break: break-all;
    }

    table {
        font-size: 11px;
    }

    .fa-solid {
        font-size: 15px;
    }

    table img {
        min-width: 40px;
        min-height: 40px;
        max-width: 40px;
        max-height: 40px;
        object-fit: cover;
    }

    .table td,
    .table th {
        padding: 8px;
    }

    .form-control,
    .pagination {
        font-size: 12px !important;
    }

    #main {
        padding: 1% 1%;
        margin: 0;
    }
}

@media screen and (max-width: 992px) {
    .titleChannel {
        font-size: 15px;
    }

    .colorTitle {
        font-size: 14px;
    }

    table {
        max-width: 100%;
        vertical-align: middle;
    }

    .nameAvatar {
        min-width: 140px;
    }

    .displaytext {
        min-width: 110px;
        overflow: hidden;
        -webkit-line-clamp: 3 !important;
        -webkit-box-orient: vertical;

    }

    .break {
        word-break: break-all;
    }

    table {
        font-size: 11px;
    }

    .fa-solid {
        font-size: 16px;
    }

    table img {
        min-width: 50px;
        min-height: 50px;
        max-width: 50px;
        max-height: 50px;
        object-fit: cover;
    }

    .table td,
    .table th {
        padding: 8px;
    }

    .form-control,
    .pagination {
        font-size: 12px !important;
    }

    #main {
        padding: 1% 1%;
        margin: 0;
    }

    .col-1,
    .col-2,
    .col-3 {
        padding-left: 0;
        padding-right: 10px;
    }

    .btn {
        padding: 0px 4px;
        margin-top: 3px;
    }

    .input-group-text {
        padding: 0 8px;
    }
}

@media screen and (max-width: 768px) {

    .titleChannel,
    .colorTitle {
        font-size: 13px;
    }

    table {
        max-width: 100%;
        vertical-align: middle;
    }

    .nameAvatar {
        min-width: 100px;
    }

    .displaytext {
        min-width: 90px;
        overflow: hidden;
        -webkit-line-clamp: 3 !important;
        -webkit-box-orient: vertical;

    }

    .break {
        word-break: break-all;
    }

    table {
        font-size: 11px;
    }

    .fa-solid {
        font-size: 13px;
    }

    table img {
        min-width: 40px;
        min-height: 40px;
        max-width: 40px;
        max-height: 40px;
        object-fit: cover;
    }

    .table td,
    .table th {
        padding: 5px;
    }

    .form-control,
    .pagination {
        font-size: 12px !important;
    }

    #page {
        min-width: 45px;
    }

    .form-control {
        padding: 1px 1px;
    }

    #main {
        padding: 1% 1%;
        margin: 0;
    }

    .col-1,
    .col-2,
    .col-3 {
        padding-right: 5px;
    }

    .btn {
        padding: 0px 4px;
        margin-top: 3px;
    }

    .input-group-text {
        padding: 0 4px;
    }

    .input-group-prepend {
        font-size: 12px;

    }
}

@media screen and (max-width: 576px) {

    .titleChannel,
    .colorTitle {
        font-size: 12px;
    }

    table {
        max-width: 100%;
        vertical-align: middle;
    }

    .nameMember {
        margin-left: 8px;
    }

    .nameAvatar {
        min-width: 100px;
    }

    .displaytext {
        min-width: 70px;
        overflow: hidden;
        -webkit-line-clamp: 3 !important;
        -webkit-box-orient: vertical;

    }

    .break {
        word-break: break-all;
    }

    table {
        font-size: 10px;
    }

    .fa-solid {
        font-size: 10px;
    }

    table img {
        min-width: 40px;
        min-height: 40px;
        max-width: 40px;
        max-height: 40px;
        object-fit: cover;
    }

    .table td,
    .table th {
        padding: 4px;
    }

    .form-control,
    .pagination {
        font-size: 10px !important;
    }

    .form-control {
        padding: 1px 1px;
        height: 25px;
    }

    #page {
        min-width: 45px;
    }

    #main {
        padding: 1% 1%;
        margin: 0;
    }

    .col-1,
    .col-2,
    .col-3 {
        padding-right: 5px;
    }

    .btn {
        padding: 0px 4px;
    }

    .input-group-text {
        padding: 0 0.5px;
    }

    .input-group-prepend {
        font-size: 11px;

    }
}

@media screen and (max-width: 424px) {

    .titleChannel,
    .colorTitle {
        font-size: 11px;
    }

    table {
        max-width: 100%;
        vertical-align: middle;
    }

    .nameMember {
        margin-left: 8px;
    }

    .nameAvatar {
        min-width: 80px;
    }

    .displaytext {
        min-width: 70px;
        overflow: hidden;
        -webkit-line-clamp: 3 !important;
        -webkit-box-orient: vertical;

    }

    .break {
        word-break: break-all;
    }

    table {
        font-size: 9px;
    }

    .fa-solid {
        font-size: 10px;
    }

    table img {
        min-width: 40px;
        min-height: 40px;
        max-width: 40px;
        max-height: 40px;
        object-fit: cover;
    }

    .table td,
    .table th {
        padding: 4px;
    }

    .form-control,
    .pagination {
        font-size: 9px !important;
    }

    .form-control {
        padding: 0.5px 0;
        height: 25px;
    }

    #page {
        min-width: 40px;
    }

    #main {
        padding: 1% 1%;
        margin: 0;
    }

    .col-1,
    .col-2,
    .col-3 {
        padding-right: 0;
    }

    .btn {
        padding: 0px 4px;
    }

    .input-group-text {
        padding: 0 0.5px;
    }

    .input-group-prepend {
        font-size: 10px;

    }

    #main .ml-2 {
        margin-left: 3px !important;
    }
}
</style>
